/** dropdown = State → Landlord → Property → Policy (default) */
export const isPolicyNumberEntryEnabled = () =>
  process.env.REACT_APP_POLICY_ENTRY_MODE === 'policyNumber';

/** Policy row from LLP portal (Policies / Applications tables) */
export const isPortalPolicyPrefill = (data) => Boolean(data?.landlord_id && data?.app_id);
